import { createFileRoute, redirect } from "@tanstack/react-router";

// /work is kept as a permanent redirect to the new /case hub so old links and
// bookmarks keep working after the IA refresh.
export const Route = createFileRoute("/work")({
  beforeLoad: () => {
    throw redirect({ to: "/case", replace: true });
  },
});
